<template>
    <hmenu></hmenu>
          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Klientat</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="ns-blog-area ns-blog-page pt-45 pb-25 ">
              <div class="container">
                  <div class="row">
                      <div v-for="client in clients" class="col-xl-4 col-lg-6 col-md-6">
                          <div class="ns-blog-item mb-30">
                              <div class="ns-blog-img w_img">
                                  <img :src="'/asetet/clients/'+client.image">
                                  <span class="ns-blog-tag">{{client.title}}</span>
                                  <span class="ns-blog-img-shape-1"></span>
                                  <span class="ns-blog-img-shape-2"></span>
                              </div>
                              <div class="ns-blog-content">
                                  <h3 class="ns-blog-content-title" v-html="client.subtitle"></h3>
                                  <span class="ns-blog-btn">{{client.description}}</span>
                                  <span class="ns-blog-shape-1"></span>
                                  <span class="ns-blog-shape-2"></span>
                              </div>
                          </div>
                      </div>  
                  </div>
              </div>
            </section>
        </main>

    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    import blogService from "@/api/blogService";

    export default {

        data () {
            return {
              selected:'info',
              clients:[]

            }
        },

        components: {
            hmenu,
            Footer,
            blogService,
         
        },



        methods:{

            tabClick(type){
              this.selected = type
            },

            async loadClients(){
              let response = await blogService.getClients();
              this.clients = response.data.data;

            }



        },

  

        mounted:function(){
            this.loadClients();
            window.scrollTo({top: 0, behavior: 'smooth'});
        }


    }

</script>



<style>


  .ns-project-details-listt ul li {
      display: flex;
      align-items: center;
      line-height: 1;
      margin-bottom: 20px;
      gap: 5px;
      font-size: 17px;
      color: var(--clr-body-text);
  }



  .kioska__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }


  .hyrja__ ul li{
    line-height: 1!important;
    margin-bottom: 0px!important;
    gap: 5px!important;
  }

  .para li{
    flex-wrap: wrap!important;
  }

</style>